import React from "react";

interface PricingCardProps {
  title: string;
  price: string;
  perSession: string;
  savings?: string;
  selected: boolean;
  onSelect: () => void;
}

const PricingCard: React.FC<PricingCardProps> = ({
  title,
  price,
  perSession,
  savings,
  selected,
  onSelect,
}) => {
  return (
    <div
      onClick={onSelect}
      style={{
        flex: "1 1 240px",
        padding: "24px",
        borderRadius: "12px",
        border: selected ? "2px solid #6366F1" : "2px solid #E5E7EB",
        backgroundColor: selected ? "#EEF2FF" : "#FFFFFF",
        cursor: "pointer",
        transition: "all 0.2s ease",
        position: "relative",
      }}
    >
      {savings && (
        <span
          style={{
            position: "absolute",
            top: "-10px",
            right: "12px",
            backgroundColor: "#6366F1",
            color: "#FFFFFF",
            fontSize: "12px",
            fontWeight: 600,
            padding: "2px 10px",
            borderRadius: "10px",
          }}
        >
          {savings}
        </span>
      )}
      <h3 style={{ margin: "0 0 8px 0", fontSize: "18px", fontWeight: 600, color: "#111827" }}>
        {title}
      </h3>
      <p style={{ margin: "0 0 4px 0", fontSize: "32px", fontWeight: 700, color: "#111827" }}>
        {price}
      </p>
      <p style={{ margin: 0, fontSize: "14px", color: "#6B7280" }}>
        {perSession}
      </p>
    </div>
  );
};

export default PricingCard;
